<template>
  <!-- Stacked (e.g. in modal): 2 per row, larger inputs -->
  <div v-if="stacked" class="engraving-mask-toolbar engraving-mask-toolbar--stacked">
    <v-row class="stacked-row">
      <v-col cols="12" sm="6" class="stacked-col">
        <v-select
          :value="numParts"
          :items="numPartsOptions"
          label="Number of images"
          hide-details
          outlined
          class="stacked-field"
          @input="$emit('update:num-parts', $event)"
        />
      </v-col>
      <v-col cols="12" sm="6" class="stacked-col">
        <v-select
          :value="direction"
          :items="directionOptions"
          label="Direction"
          hide-details
          outlined
          class="stacked-field"
          @input="$emit('update:direction', $event)"
        />
      </v-col>
    </v-row>
    <v-row class="stacked-row">
      <v-col cols="12" sm="6" class="stacked-col">
        <v-select
          :value="shape"
          :items="shapeOptions"
          label="Shape"
          hide-details
          outlined
          class="stacked-field"
          @input="$emit('update:shape', $event)"
        />
      </v-col>
      <v-col cols="12" sm="6" class="stacked-col">
        <v-select
          :value="spacing"
          :items="spacingOptions"
          label="Space between parts"
          hide-details
          outlined
          class="stacked-field"
          @input="$emit('update:spacing', $event)"
        />
      </v-col>
    </v-row>
    <v-row class="stacked-row">
      <v-col cols="12" sm="6" class="stacked-col">
        <v-select
          :value="outputSize"
          :items="sizeOptions"
          label="Output size"
          hide-details
          outlined
          class="stacked-field"
          @input="$emit('update:output-size', $event)"
        />
      </v-col>
    </v-row>
  </div>
  <!-- Default: horizontal toolbar -->
  <v-toolbar v-else rounded class="mb-4">
    <v-toolbar-title class="text-h6">Engraving Mask</v-toolbar-title>
    <v-spacer />
    <v-select
      :value="numParts"
      :items="numPartsOptions"
      label="Number of images"
      dense
      hide-details
      style="max-width: 160px"
      class="mr-2"
      @input="$emit('update:num-parts', $event)"
    />
    <v-select
      :value="direction"
      :items="directionOptions"
      label="Direction"
      dense
      hide-details
      style="max-width: 140px"
      class="mr-2"
      @input="$emit('update:direction', $event)"
    />
    <v-select
      :value="shape"
      :items="shapeOptions"
      label="Shape"
      dense
      hide-details
      style="max-width: 140px"
      class="mr-2"
      @input="$emit('update:shape', $event)"
    />
    <v-select
      :value="spacing"
      :items="spacingOptions"
      label="Space between parts"
      dense
      hide-details
      style="max-width: 180px"
      class="mr-2"
      @input="$emit('update:spacing', $event)"
    />
    <v-select
      :value="outputSize"
      :items="sizeOptions"
      label="Output size"
      dense
      hide-details
      style="max-width: 140px"
      class="mr-2"
      @input="$emit('update:output-size', $event)"
    />
  </v-toolbar>
</template>

<script>
import { NUM_PARTS_OPTIONS, DIRECTION_OPTIONS, SHAPE_OPTIONS, SIZE_OPTIONS, SPACING_OPTIONS } from './constants'

export default {
  name: 'EngravingMaskToolbar',
  props: {
    numParts: { type: Number, default: 2 },
    direction: { type: String, default: 'horizontal' },
    shape: { type: String, default: 'circle' },
    spacing: { type: Number, default: 0 },
    outputSize: { type: Number, default: 512 },
    /** When true, render options stacked vertically (e.g. in a modal). */
    stacked: { type: Boolean, default: false },
  },
  data() {
    return {
      numPartsOptions: NUM_PARTS_OPTIONS,
      directionOptions: DIRECTION_OPTIONS,
      shapeOptions: SHAPE_OPTIONS,
      sizeOptions: SIZE_OPTIONS,
      spacingOptions: SPACING_OPTIONS,
    }
  },
}
</script>

<style scoped>
.engraving-mask-toolbar--stacked .stacked-row {
  margin-bottom: 8px;
}
.engraving-mask-toolbar--stacked .stacked-row:last-child {
  margin-bottom: 0;
}
.engraving-mask-toolbar--stacked .stacked-col {
  padding-top: 8px;
  padding-bottom: 8px;
}
.engraving-mask-toolbar--stacked .stacked-field {
  min-height: 48px;
}
</style>
